<template>
  <div class="header">
    <div class="nav" :style="{ top: showNav ? '0' : '-18vw' }">
      <img
        src="https://summit-img.geekpark.net/if2021/m/创新大会2021.svg"
        style="width: 88.1vw; height: auto"
      />
      <img
        src="https://summit-img.geekpark.net/if2021/m/000-m-叉.svg"
        style="width: 11.9vw; height: 11.9vw"
        v-show="showNavItems"
        @click="toggleNavsVisible"
      />
      <img
        src="https://summit-img.geekpark.net/if2021/m/菜单栏-m.svg"
        style="width: 11.9vw; height: 11.9vw"
        v-show="!showNavItems"
        @click="toggleNavsVisible"
      />
      <ul class="navs" v-show="showNavItems">
        <li v-for="(item, index) in navs" :key="index">
          <a href @click.prevent="scrollToPosition(item.position)">
            <img :src="item.name" :style="item.style" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      showNav: false,
      showNavItems: false,
      curScrollHeight: 0,
      navs: [
        {
          name: "https://summit-img.geekpark.net/if2021/m/000-m-论坛介绍.svg",
          position: "#if2021-forum-desc", // 锚点id
        },
        {
          name: "https://summit-img.geekpark.net/if2021/m/000-m-主题日程.svg",
          position: "#if2021-kv",
        },
        {
          name: "https://summit-img.geekpark.net/if2021/m/000-m-合作伙伴.svg",
          position: "#if2021-partner",
        },
        {
          name: "https://summit-img.geekpark.net/if2021/m/000-m-往届回顾.svg",
          position: "#if2021-last-years",
        },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleNavScroll);
  },
  methods: {
    getElementTop(element) {
      let actualTop = element.offsetTop;
      let current = element.offsetParent;

      while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
      }

      return actualTop;
    },
    handleNavScroll(e) {
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const scrollInstance = scrollHeight - this.curScrollHeight;
      this.curScrollHeight = scrollHeight;
      if (scrollInstance >= 0) {
        this.showNav = true;
      } else {
        this.showNav = false;
        this.showNavItems = false;
      }
    },
    toggleNavsVisible() {
      this.showNavItems = !this.showNavItems;
    },
    scrollToPosition(id) {
      if (id.startsWith("#")) {
        const navsHeight = document.querySelector(".nav").offsetHeight;
        const position = this.getElementTop(document.querySelector(id));
        window.scrollTo({
          top: position - navsHeight,
          behavior: "smooth",
        });
      } else {
        window.open(id, "blank");
      }
      this.showNavItems = false;
      return false;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleNavScroll);
  },
};
</script>

<style scoped lang="less">
.header {
  position: relative;
}

.nav {
  background: #f3f3f3;
  box-sizing: border-box;
  position: fixed;
  width: 100vw;
  height: 12vw;
  left: 0;
  top: 0;
  text-align: left;
  z-index: 100;
  transition: top 0.3s;
  display: flex;
  align-items: flex-start;
}

ul.navs {
  position: absolute;
  top: 100%;
  width: 100%;
  left: 0;
  padding: 12vw 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #f0f0f0;
  transition: opacity 0.3s linear;

  li {
    height: 12vw;
    list-style: none;
    height: 12vw;
    list-style: none;
    display: flex;
    justify-content: center;
    margin-bottom: 10px;

    a {
      width: 64vw;
      color: #1d1d1d;
      text-decoration: none;
      text-align: center;
      &:active {
        background: #fcf351;
      }
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
